import { type DefaultMessagesResponse, createPlacement } from '@post-office/placement-common-v2';
import { usePlacementApi } from '@post-office/use-placement-api';
// @ts-expect-error: 'React' is declared but its value is never read
import React, { type PropsWithChildren } from 'react';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'jira-nin-saved-filters-menu',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
});

export const PlacementFrontend = createFrontend<PropsWithChildren>((Messages) => ({ children }) => {
	const { data, error, isLoading } = usePlacementApi<DefaultMessagesResponse>('/');

	if (!children) {
		return null;
	}

	if (error || isLoading || data.messages.length === 0) {
		return <>{children}</>;
	}

	const [message] = data.messages;
	return <Messages.render {...message}>{children}</Messages.render>;
});

export const PlacementBackend = createBackend();
